<template>
  <div class="detail-box">
    <div class="course-info-box">
      <img class="course-cover" :src="bookCover" alt="" />
      <div class="course-title">
        {{ courseDetail.courseName }}
      </div>
      <div class="text">
        <img src="../../../assets/icon/course_icon1.png" alt="" />
        <span>{{ courseDetail.className }}</span>
      </div>
      <div class="text">
        <img src="../../../assets/icon/course_icon2.png" alt="" />
        <span>{{ courseDetail.teacherName }}</span>
      </div>
      <div class="text">
        <img src="../../../assets/icon/course_icon3.png" alt="" />
        <span>{{
          parseTime(courseDetail.createTime, "{y}-{m}-{d} {h}:{i}")
        }}</span>
      </div>

      <div class="btn">
        <div class="name">
          <img src="../../../assets/icon/book_icon.png" alt="" />
          <div>{{ bookTitle }}</div>
        </div>
        <div class="read" @click="ToRead()">立即阅读 ></div>
      </div>
    </div>
    <div class="resources-box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="课堂活动" name="first">
          <ClassActivities
            ref="ClassActivities"
            :courseData="courseDetail"
          ></ClassActivities>
        </el-tab-pane>
        <el-tab-pane label="班级成员" name="second">
          <ClassMembers
            ref="ClassMembers"
            :courseData="courseDetail"
          ></ClassMembers>
        </el-tab-pane>
        <el-tab-pane label="学况一览" name="third">
          <LearnSituation
            ref="LearnSituation"
            :courseData="courseDetail"
            :goodInfo="fileInfo"
          >
          </LearnSituation>
        </el-tab-pane>
        <el-tab-pane label="阅读统计" name="fourth" v-if="isBuy">
          <ReadStatistics
            ref="ReadStatistics"
            :courseData="courseDetail"
            :goodInfo="fileInfo"
          >
          </ReadStatistics>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import ClassActivities from "./components/ClassActivities";
import ClassMembers from "./components/ClassMembers.vue";
import LearnSituation from "./components/LearnSituation.vue";
import ReadStatistics from "./components/ReadStatistics.vue";
import { goodsInfoDetail } from "@/api/bookstore/bookstore";
import { checkIsBuy } from "@/api/bookstore/bookstore";
export default {
  components: {
    ClassActivities,
    ClassMembers,
    LearnSituation,
    ReadStatistics,
  },
  data() {
    return {
      activeName: "first",
      courseDetail: {},
      bookTitle: "",
      bookCover: "",
      fileInfo: {}, //商品详情
      isBuy: false, //是否购买商品
    };
  },
  watch: {
    $route() {
      if (this.$route.path == "/course/detail") {
        this.courseDetail = this.$router.currentRoute.query;
        this.getGoodInfo();
      }
    },
  },
  created() {
    this.courseDetail = this.$router.currentRoute.query;
  },

  mounted() {
    this.getGoodInfo();
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        this.$refs.ClassActivities.getlist();
      }
    });
  },
  methods: {
    handleClick(e) {
      if (e.index == "0") {
        this.$refs.ClassActivities.getlist();
      }
    },
    getGoodInfo() {
      goodsInfoDetail(this.courseDetail.goodsId).then((res) => {
        this.bookCover = res.data.coverFiles[0].fullUrl;
        this.bookTitle = res.data.goods.goodsTitle;
        this.fileInfo = res.data.sourceList[0];
        this.checkUserBuy();
      });
    },

    checkUserBuy() {
      checkIsBuy({
        relevanceId: this.courseDetail.goodsId,
        type: "goods",
      }).then((res) => {
        if (res.data == "0") {
          //有权限
          this.isBuy = true;
        } else {
          //无权限
          this.isBuy = false;
        }
      });
    },

    ToRead() {
      if (this.isBuy) {
        // goodsId=1752353843863228416&relevanceId=1752353843863228416&resource=distribute&resourceType=goods&typeName=1&teachInstId=15498
        const hrefs = this.$router.resolve({
          path: "/onlineReading",
          query: {
            pageType: "pc",
            businessType: "textBook",
            goodsId: this.fileInfo.goodsId,
            relevanceId: this.fileInfo.goodsId,
            textBookId: this.fileInfo.filesId,
            bookName: this.fileInfo.sourceName,
            resource: this.$route.query.resource || "distribute",
            resourceType: this.$route.query.resourceType || "goods",
            teachInstId: this.$route.query.teachInstId || "",
          },
        });
        window.open(hrefs.href, "_blank");
      } else {
        this.$message.warning("暂无权限，请联系管理员");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.detail-box {
  margin: 0 auto;
  width: 1400px;
  display: flex;
  padding-bottom: 40px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  .course-info-box {
    width: 304px;
    height: 704px;
    background: #ffffff;
    padding: 20px;
    box-sizing: border-box;

    .course-cover {
      width: 264px;
      height: 264px;
      border-radius: 5px;
    }

    .course-title {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      margin-top: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }

    .text {
      display: flex;
      align-items: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      margin-top: 13px;

      img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }

      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .btn {
      width: 263px;
      height: 40px;
      background: #f2f2f2;
      border-radius: 10px 10px 10px 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 19px;
      padding: 0 10px;

      .name {
        width: 70%;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        display: flex;
        align-items: center;

        img {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }

        > div {
          width: 70%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .read {
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #2e9adb;
      }
    }
  }

  .resources-box {
    width: calc(100% - 320px);
    min-height: 704px;
    background: #ffffff;

    &::v-deep {
      .el-tabs__item {
        height: 50px;
        line-height: 50px;
      }
    }
  }
}
</style>
